import ky from "ky";

import type { ConsentTypes } from "@solvari/utils";

import { getEnv, returnNetworkError } from "@solvari/utils";

import type { ArgusEvent } from "@/service/backendSync";

type Summary = {
  cookieConsent: ConsentTypes | null;
  currentPage: string;
  currentPageReferrer: string | null;
  domain: string;
  experiments: Record<string, number | string>;
  fbclid: string | null;
  gclid: string | null;
  landingPage: string | null;
  landingPageReferrer: string | null;
  seaAdGroupId: string | null;
  seaAdId: string | null;
  seaCampaignId: string | null;
  seaClickId: string | null;
  seaPlatform: string | null;
  userAgent: string;
  utmCampaign: string | null;
  utmContent: string | null;
  utmMedium: string | null;
  utmSource: string | null;
  utmTerm: string | null;
  uuid: string;
};

const argusGetSummary = returnNetworkError(async (uuid: string) => {
  return (
    await ky
      .get(`${getEnv().network.argus}/api/v1/summarize/${uuid}`)
      .json<{ data: Summary }>()
  ).data;
});

const argusTrack = returnNetworkError(
  async (events: ArgusEvent[], uuid: string) => {
    await ky.post(`${getEnv().network.argus}/api/v1/track`, {
      json: { uuid, events },
    });
  },
);

export type { Summary };
export { argusGetSummary, argusTrack };
